
import React, { useState } from "react";
import { db } from "../firebase";
import { collection, query, where, getDocs } from "firebase/firestore";

const ParcenalCenter = () => {
  const [showGroups, setShowGroups] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleApplyGroup = async () => {
    setLoading(true);
    setError("");

    try {
      // Chukua username kutoka localStorage
      const username = localStorage.getItem("username");
      console.log("Username from localStorage:", username);

      if (!username) {
        setError("⚠️ Tafadhali ingia kwanza.");
        setLoading(false);
        return;
      }

      // Function ya ku-check success transaction
      const checkTransactions = async (collectionName) => {
        const q = query(
          collection(db, collectionName),
          where("username", "==", username),
          where("status", "==", "success")
        );

        const snapshot = await getDocs(q);
        console.log(`Snapshot docs for ${collectionName}:, snapshot.docs.map(doc => doc.data())`);

        return !snapshot.empty;
      };

      // Angalia transactions kwenye TSH au USDT
      const hasTsh = await checkTransactions("tsh_transactions"); // plural
      const hasUsdt = await checkTransactions("usdt_transactions"); // plural

      console.log("Has TSH:", hasTsh, "Has USDT:", hasUsdt);

      // Rule: user aruhusiwe kama ana yeyote
      if (hasTsh || hasUsdt) {
        setShowGroups(true);
        setError("");
      } else {
        setError(
          "⚠️ Hauwezi kujoin groups. Tafadhali hakikisha ume deposit."
        );
      }
    } catch (err) {
      console.error("Error checking transactions:", err);
      setError("❌ Kuna tatizo. Jaribu tena.");
    }

    setLoading(false);
  };

  return (
    <div
      style={{
        padding: "20px",
        maxWidth: "800px",
        margin: "20px auto",
        backgroundColor: "#333",
        borderRadius: "10px",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
      }}
    >
      <h2 style={{ textAlign: "center", color: "#4caf50" }}>
        👤 Parcenal Center
      </h2>

      <p style={{ lineHeight: "1.8", fontSize: "16px", color: "#eee" }}>
        Hii ni <strong>sehemu yako binafsi</strong> ya kufuatilia safari yako
        ndani ya <strong>FES</strong>.  
        Hapa ndipo kila kitu chako muhimu unachotakiwa kulinda kwa urahisi na
        uwazi. 🏆
      </p>

      <ul style={{ lineHeight: "1.8", fontSize: "16px", color: "#eee" }}>
        <li>📌 Akaunti yako na jina ulilosajili FES Usilitoe kwa yeyote.</li>
        <li>💰 Fuatilia salio la faida na historia ya deposit/ushindi wako.</li>
        <li>📊 Weka malengo yako ya kuwekeza na uone maendeleo kila wakati.</li>
        <li>🚀 Pata mwongozo wa kuongeza faida na kushirikiana na wachezaji wengine.</li>
        <li>🔗 Tumia kadi ya mwaliko (invite code & referral link) kuleta marafiki.</li>
        <li>🛡️ Linda account yako, usitoe taarifa nyeti kwa wengine.</li>
        <li>⚠️ Uzembe unaweza kusababisha account kufungwa au kusimamishwa.</li>
      </ul>

      <div style={{ textAlign: "center", marginTop: "30px" }}>
        <button
          onClick={handleApplyGroup}
          disabled={loading}
          style={{
            background: "#4caf50",
            color: "#fff",
            padding: "10px 20px",
            border: "none",
            borderRadius: "8px",
            cursor: loading ? "not-allowed" : "pointer",
            fontSize: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          {loading ? (
            <>
              <span className="spinner" style={{
                width: "18px",
                height: "18px",
                border: "3px solid #fff",
                borderTop: "3px solid transparent",
                borderRadius: "50%",
                animation: "spin 1s linear infinite"
              }}></span>
              Checking...
            </>
          ) : (
            "Apply Group"
          )}
        </button>

        {error && (
          <p style={{ color: "red", marginTop: "15px", fontWeight: "bold" }}>
            {error}
          </p>
        )}

        {showGroups && (
          <div style={{ marginTop: "20px" }}>
            <h3 style={{ color: "#fff" }}>Telegram Groups</h3>
            <button
              onClick={() =>
                window.open("https://t.me/footballexchangesscore", "_blank")
              }
              style={{
                margin: "5px",
                padding: "10px 15px",
                border: "none",
                borderRadius: "6px",
                background: "#0088cc",
                color: "#fff",
                cursor: "pointer",
              }}
            >
              Telegram Channel
            </button>
            <button
              onClick={() =>
                window.open("https://t.me/+Y53_52f9vYFkNDU0", "_blank")
              }
              style={{
                margin: "5px",
                padding: "10px 15px",
                border: "none",
                borderRadius: "6px",
                background: "#0088cc",
                color: "#fff",
                cursor: "pointer",
              }}
            >
              Telegram Group
            </button>

            <h3 style={{ marginTop: "15px", color: "#fff" }}>
              WhatsApp Channel
            </h3>
            <button
              onClick={() =>
                window.open(
                  "https://chat.whatsapp.com/BzyRoPtjff0LQ0qBqzBjBW?mode=ems_copy_t",
                  "_blank"
                )
              }
              style={{
                margin: "5px",
                padding: "10px 15px",
                border: "none",
                borderRadius: "6px",
                background: "#25d366",
                color: "#fff",
                cursor: "pointer",
              }}
            >
              WhatsApp Channel
            </button>
          </div>
        )}
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default ParcenalCenter;